import React from 'react';
import BookSearch from './BookSearch';

function App() {
  return (
    <div className="App">
      <BookSearch />
    </div>
  );
}

export default App;